import { render } from "./ProComponent.vue?vue&type=template&id=3fd92a02&scoped=true"
import script from "./ProComponent.vue?vue&type=script&lang=js"
export * from "./ProComponent.vue?vue&type=script&lang=js"

import "./ProComponent.vue?vue&type=style&index=0&id=3fd92a02&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fd92a02"]])

export default __exports__